<template>
  <div>
    <v-dialog v-model="VideoCallDialog" dense persistent width="400px">
      <v-card>
        <v-toolbar
          color="blueColorVariant9"
          class="white--text elevation-0"
          dense
          >Incoming Call</v-toolbar
        >
        <div align="center">
          <v-img width="100px" src="@/assets/CallRing.gif"></v-img>
        </div>
        <div align="center" class="mt-3">
          Incoming call from Motorist<span class="font-weight-bold">
            {{ this.$store.getters.get_motorist_name.user_name }}
          </span>
        </div>
        <v-card-actions>
          <v-spacer />
          <v-btn small depressed @click="VideoCallEmit(1)" color="red" dark
            >Reject</v-btn
          >
          <v-btn
            small
            depressed
            @click="$router.push('/VideoCall')"
            dark
            color="green"
            >Answer</v-btn
          >
        </v-card-actions>
      </v-card></v-dialog
    >
  </div>
</template>

<script>
export default {
  props: {
    VideoCallDialog: Boolean,
  },
  data: () => ({}),
  methods: {
    VideoCallEmit(Toggle) {
      this.$emit("clicked", Toggle);
    },
  },
};
</script>
